import { BehaviorSubject } from 'rxjs';
import { deepFreeze, getUrlSearchParameters } from '../utils';
const URL_PARAMS_TO_KEEP = ['project'];
export class UxaContextService {
    constructor(projectId, uxaContextClient) {
        this.projectId = projectId;
        this.uxaContextClient = uxaContextClient;
        this.currentContext$ = new BehaviorSubject({});
    }
    async init() {
        if (typeof window === 'undefined') {
            return {};
        }
        const hash = this.getHashFromUrl();
        let ctx;
        if (hash) {
            try {
                ctx = await this.uxaContextClient.get(this.projectId, hash);
            }
            catch (_) { }
        }
        else {
            const latestContext = await this.uxaContextClient.getLatest(this.projectId);
            ctx = latestContext === null || latestContext === void 0 ? void 0 : latestContext.context;
        }
        if (!ctx) {
            ctx = {};
        }
        this.notifyContextChanged(ctx);
        return ctx;
    }
    getContext() {
        return this.currentContext$.value;
    }
    get context$() {
        return this.currentContext$.asObservable();
    }
    async saveContext(context) {
        return this.uxaContextClient.save(this.projectId, context);
    }
    async applyContext(context) {
        return this.saveContext(context)
            .then((hash) => this.updateHashInUrl(hash))
            .then(() => {
            this.notifyContextChanged(context);
        });
    }
    getHashFromUrl() {
        return getUrlSearchParameters().get('hash');
    }
    updateHashInUrl(hash) {
        const urlParams = getUrlSearchParameters();
        urlParams.set('hash', hash);
        const filteredParams = URL_PARAMS_TO_KEEP.reduce((result, key) => {
            if (urlParams[key]) {
                result[key] = urlParams[key];
            }
            return result;
        }, {});
        location.hash = filteredParams.toString();
    }
    notifyContextChanged(context) {
        this.currentContext$.next(deepFreeze(context));
    }
}
//# sourceMappingURL=uxa-context.service.js.map